import { coerceWorkload } from "./workloadState";
import type { Workload } from "./types";

export type ScenarioSnapshot = {
  workload: Workload;
  userMult: number;
  reqMult: number;
  totalMonthlyUsd: number;
};

export function coerceScenarioSnapshot(x: unknown): ScenarioSnapshot | null {
  if (!x || typeof x !== "object") return null;
  const o = x as Record<string, unknown>;
  const w = coerceWorkload(o.workload);
  if (!w) return null;
  const userMult = Number(o.userMult);
  const reqMult = Number(o.reqMult);
  const totalMonthlyUsd = Number(o.totalMonthlyUsd);
  if (!Number.isFinite(userMult) || !Number.isFinite(reqMult)) return null;
  if (!Number.isFinite(totalMonthlyUsd)) return null;
  return {
    workload: w,
    userMult,
    reqMult,
    totalMonthlyUsd,
  };
}
